module.exports = __webpack_public_path__ + "static/media/V86-label.9a962b2b.png";